import FocusLock from './Lock';
import AutoFocusInside from './AutoFocusInside';
import MoveFocusInside from './MoveFocusInside';
import FreeFocusInside from './FreeFocusInside';
export { AutoFocusInside, MoveFocusInside, FreeFocusInside };
export default FocusLock;